import { useContext } from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  Checkbox
} from '@mui/material';
import { BrowseContext, BrowseContextType } from 'src/contexts/BrowseContext';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FilterByFormControlLabel } from '../../Layout/FilterByCheckBox';
import { FacetCount } from './FacetCount';
import { FACET_NAMES, FACET_VALUES_PROGRAM_LEVELS } from './constants';

const FilterByProgramLevels = () => {
  const { programLevels, setProgramLevels, setLastChangeFacet } = useContext(
    BrowseContext
  ) as BrowseContextType;
  const handleChange = (event: any) => {
    const isChecked = event.target.checked;
    setLastChangeFacet(FACET_NAMES.ProgramLevels);
    if (isChecked) {
      setProgramLevels([...programLevels, event.target.value]);
    } else {
      const newProgramLevels = programLevels.filter((value) => value !== event.target.value);
      setProgramLevels(newProgramLevels);
    }
  };
  const isChecked = (value: string): boolean => {
    return programLevels.includes(value);
  };
  return (
    <Box>
      <Accordion defaultExpanded={true} elevation={0} disableGutters>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="programLevels-content"
          id="programLevels-header"
          sx={{ minHeight: 'initial' }}
        >
          <Typography variant="subtitle2" color="primary">
            CPD Program Level Requirements{' '}
            {programLevels.length > 0 && '(' + programLevels.length + ')'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingTop: 0 }}>
          <FormGroup>
            {FACET_VALUES_PROGRAM_LEVELS.map((programLevels) => (
              <FilterByFormControlLabel
                key={programLevels.value}
                sx={{ width: '100%' }}
                control={
                  <Checkbox
                    onChange={handleChange}
                    value={programLevels.label}
                    checked={isChecked(programLevels.label)}
                  />
                }
                label={
                  <Box sx={{ display: 'flex', width: '100%' }}>
                    <Box>{programLevels.label}</Box>{' '}
                    <FacetCount
                      facetName={FACET_NAMES.ProgramLevels}
                      facetValueString={programLevels.label}
                    />
                  </Box>
                }
              />
            ))}
          </FormGroup>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export { FilterByProgramLevels };
